import React, { createContext } from 'react';
import {
    AddressType,
    ProductType,
    VehicleType
} from '../components/common/CommonTypes';
import { ProgressBarItem } from '../components/common/progressBar/ProgressBar';
import {
    AlloyPageState,
    AlloyProcessStages
} from '../components/sitePages/alloyRepairRequest/AlloyRepairRequestTypes';

export type AlloyRepairRequestContextState = {
    product: ProductType;
    vehicle: VehicleType;
    progressBarItems: ProgressBarItem[];
    alloyRepairRequest: AlloyPageState;
    onSelectAlloyType: (selectionName: string) => void;
    onChangeMileage: (event: React.FormEvent<HTMLInputElement>) => void;
    onWheelValueChange: (key: string, value: string) => void;
    onAlloyWheelRepairRequestChangeWheel: (value: string, key: string) => void;
    onWheelSelected: (wheel: string) => void;
    onChangeDamageType: (selectionName: string) => void;
    onRepairAddressSelectionChanged: (selectedId: string | null) => void;
    onRepairAddressAdded: (address: AddressType) => void;
    onRepairAddressUpdated: (id: string, address: AddressType) => void;
    onUploadImageChange: (
        imageType: string,
        uploadedPath: string,
        imageId: string,
        image: string,
        filename: string
    ) => void;
    onFinishAddingWheels: () => boolean;
    onTogglePermission: (isChecked: boolean) => void;
    onFinishedAlloyRepairRequest: () => void;
    onContinueRepairRequest: () => void;
    onContinueToRepairAddress: () => void;
    onDeleteRepairRequest: (wheel: string) => void;
    onCancelClick: () => void;
    onCancelRepairRequest: () => void;
    onCancelUndo: () => void;
    onChangeStage: (stage: AlloyProcessStages) => void;
    onUpdateWheelClick: (wheel: string) => void;
    onUpdateAddressClick: (scrollToAddress: boolean) => void;
    onRepairAddressUpdate: (repairAddress: AddressType) => void;
};

const initialState: AlloyRepairRequestContextState = {
    product: undefined,
    vehicle: undefined,
    progressBarItems: undefined,
    alloyRepairRequest: undefined,
    onSelectAlloyType: undefined,
    onChangeMileage: undefined,
    onWheelValueChange: undefined,
    onAlloyWheelRepairRequestChangeWheel: undefined,
    onWheelSelected: undefined,
    onChangeDamageType: undefined,
    onRepairAddressSelectionChanged: undefined,
    onRepairAddressAdded: undefined,
    onRepairAddressUpdated: undefined,
    onUploadImageChange: undefined,
    onFinishAddingWheels: undefined,
    onTogglePermission: undefined,
    onFinishedAlloyRepairRequest: undefined,
    onContinueRepairRequest: undefined,
    onContinueToRepairAddress: undefined,
    onDeleteRepairRequest: undefined,
    onCancelClick: undefined,
    onCancelRepairRequest: undefined,
    onCancelUndo: undefined,
    onChangeStage: undefined,
    onUpdateWheelClick: undefined,
    onUpdateAddressClick: undefined,
    onRepairAddressUpdate: undefined
};

export const AlloyRepairRequestContext = createContext(initialState);
